var be = Object.defineProperty;
var Ve = (e, l, C) => l in e ? be(e, l, { enumerable: !0, configurable: !0, writable: !0, value: C }) : e[l] = C;
var K = (e, l, C) => Ve(e, typeof l != "symbol" ? l + "" : l, C);
import { createElementBlock as r, openBlock as d, createElementVNode as t, defineComponent as ve, defineAsyncComponent as u, ref as O, watch as ce, computed as P, resolveComponent as m, resolveDirective as fe, createVNode as n, renderSlot as we, createBlock as c, withCtx as i, createCommentVNode as M, normalizeClass as z, toDisplayString as a, createTextVNode as v, Fragment as f, mergeProps as w, createSlots as E, resolveDynamicComponent as g, renderList as H, withDirectives as ke } from "vue";
import { a as Te, f as Q } from "./index-CZzSx_Qo.js";
import { f as W, r as D, u as x, m as _, g as Pe } from "./vuelidate-04GJpzoE.js";
import { D as ge, r as Ie, a as Se, b as Ce } from "./DemoSection-CBEo8w66.js";
import { _ as ye } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function he(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "fill-rule": "evenodd",
      d: "M4.5 9.75a6 6 0 0 1 11.573-2.226 3.75 3.75 0 0 1 4.133 4.303A4.5 4.5 0 0 1 18 20.25H6.75a5.25 5.25 0 0 1-2.23-10.004 6.072 6.072 0 0 1-.02-.496Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ue(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 6 6 9-13.5"
    })
  ]);
}
function Me(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    })
  ]);
}
function j(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
    })
  ]);
}
function Ye(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
    })
  ]);
}
function ee(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    })
  ]);
}
function De(e, l) {
  return d(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    t("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    })
  ]);
}
const Fe = ve({
  components: {
    ChevronUpIcon: Ce,
    ChevronDownIcon: Se,
    CheckIcon: Ue,
    CloudIcon: he,
    EllipsisVerticalIcon: Me,
    TrashIcon: De,
    ArrowPathIcon: Ie,
    DemoSection: ge,
    TButtonIcon: u(() => import("./ButtonIcon-D4squ00_.js")),
    TButton: u(() => import("./Button-CkAyItqk.js")),
    TCheckboxes: u(() => import("./Checkboxes-CLFGhdUm.js")),
    TCheckbox: u(() => import("./Checkbox-B8p-bKhv.js")),
    TCombobox: u(() => import("./Combobox-zKa2lri2.js")),
    TDatetime: u(() => import("./Datetime-BEqKzt4-.js")),
    TDropdown: u(() => import("./Dropdown-Cy_Jl-0g.js")),
    TInputEmail: u(() => import("./InputEmail-CSNxzrre.js")),
    TInputPassword: u(() => import("./InputPassword-CFcOJ5HW.js")),
    TInputSearch: u(() => import("./InputSearch-DPusY0z8.js")),
    TInputTel: u(() => import("./InputTel-Btcgb43z.js")),
    TInputUrl: u(() => import("./InputUrl-Y_csVNO8.js")),
    TInput: u(() => import("./Input-KouLK2QK.js")),
    TRadio: u(() => import("./Radio-BohqdGUL.js")),
    TSelect: u(() => import("./Select-Dmjule_0.js")),
    TSwitch: u(() => import("./Switch-DBG6RDCK.js")),
    TInputIcon: u(() => import("./InputIcon-DYMgHv8r.js")),
    TInputNumber: u(() => import("./InputNumber-CJ1ZLzd0.js")),
    TInputNumberInteger: u(() => import("./InputNumberInteger-B5sjop0Q.js")),
    TInputNumberFloat: u(() => import("./InputNumberFloat-CjOBLBJt.js")),
    TInputNumberDuration: u(() => import("./InputNumberDuration-CGgyR8Yg.js")),
    TInputNumberPercent: u(() => import("./InputNumberPercent-DghiTrSE.js"))
  },
  slots: Object,
  setup() {
    const e = O([...Array(10)].map(() => !1)), l = O([...Array(10)].map(() => !1)), C = `${W.formatter.dateFormat}, ${W.formatter.timeFormat}`, J = ["primary", "secondary", "tertiary", "white", "red", "dashed", "gray", "success", "warning", "danger", "light", "medium", "dark"], R = ["solid", "outline"], X = ["tr", "tl", "br", "bl", "r", "l"], L = ["text", "number", "custom"], $ = O({
      date1: { required: D },
      input: { required: D }
    });
    function F(s) {
      return {
        _type: s,
        placeholder: "placeholder",
        default: "exemple",
        disabled: !1,
        start: s === "text" ? "->" : "",
        end: "€",
        startIcon: s === "text" ? ee : void 0,
        endIcon: s === "text" ? j : void 0,
        errorPosition: "bl",
        // integer / float
        min: 0,
        max: 500,
        step: void 0,
        stepMandatory: !1,
        precision: 2,
        // text
        multiline: !1,
        rows: void 0,
        maxlength: void 0
      };
    }
    const { refObj: p, validationObj: k } = x(
      {
        switch1: void 0,
        checkboxes: [],
        checkbox1: !0,
        checkbox2: void 0,
        combobox1: null,
        combobox2: [],
        combobox21: [],
        combobox3: null,
        combobox4: null,
        combobox5: null,
        select1: null,
        select2: null,
        select3: null,
        select3a: oe[1],
        select4: [],
        select5: [],
        select6: null,
        select7: [],
        select8: 2,
        select9: [2, 3],
        select10: null,
        select11: null,
        select12: [],
        inputParam: F(L[1]),
        input: void 0,
        inputTestFormatter: void 0,
        inputS1: 75,
        inputS2: "toto@gg.fr",
        inputS3: "secretpassword",
        inputS4: 0.13,
        inputS5: "search",
        inputS6: "01 22 33 44 55",
        inputS7: "http://tolemac.io",
        inputS8: 2,
        inputS9: 2.34,
        date1: void 0,
        date2: void 0,
        date3: void 0,
        date4: void 0,
        date5: void 0,
        date6: void 0,
        date7: void 0,
        date8: void 0
      },
      $,
      { skipLockDirty: !0 }
    );
    ce(() => p.value.inputParam._type, (s, V) => {
      s !== V && (p.value.inputParam = F(s));
    });
    const { validationObj: b } = x({}, { required: D }, { skipLockDirty: !0 });
    return {
      testInputFormatter: new Le(),
      dropdownItems: [
        { title: "dropdown items:", borderB: !0 },
        { title: "Modifier", icon: j, click() {
          console.log("click Modifier");
        } },
        { title: "Ajouter", click() {
          console.log("click Ajouter");
        } },
        { title: "Supprimer", click() {
          console.log("click Supprimer");
        } }
      ],
      searchPeople: async (s, V = 0) => (V && await new Promise((T) => setTimeout(T, V)), le.filter((T) => T.firstname.indexOf(s) !== -1 || T.lastname.indexOf(s) !== -1).splice(0, 5)),
      labelPerson: (s) => `${s.firstname} ${s.lastname}`,
      model: p,
      model$: k,
      model$vargs: $,
      invalid: b,
      sections: e,
      extraSections: l,
      allSectionsIsOpened: P(() => e.value.concat(l.value).some((s) => s === !0)),
      setAllSections(s) {
        e.value.forEach((V, T) => {
          e.value[T] = s;
        }), l.value.forEach((V, T) => {
          l.value[T] = s;
        });
      },
      async consoleLog(s = "click") {
        console.log(s);
      },
      dateF(s, V) {
        return s ? (typeof s == "number" && (s = new Date(s)), s = new Date(s.getTime() + s.getTimezoneOffset() * 60 * 1e3), Q(s, V || C)) : ".";
      },
      dateLocalF(s, V) {
        return s ? Q(s, V || C) : ".";
      },
      inputParamInputDuration: P(() => ({ ...p.value.inputParam })),
      inputParamInputEmail: P(() => ({ ...p.value.inputParam })),
      inputParamInputPassword: P(() => ({ ...p.value.inputParam })),
      inputParamInputPercent: P(() => {
        const { step: s, end: V, min: T, max: y, ...h } = p.value.inputParam;
        return h;
      }),
      inputParamInputSearch: P(() => ({ ...p.value.inputParam })),
      inputParamInputTel: P(() => ({ ...p.value.inputParam })),
      inputParamInputUrl: P(() => ({ ...p.value.inputParam })),
      inputParamInputInteger: P(() => {
        const { precision: s, ...V } = p.value.inputParam;
        return V;
      }),
      inputParamInputFoat: P(() => {
        const { precision: s, ...V } = p.value.inputParam;
        return V;
      }),
      // testMargin: ref({
      //     select: categories[0],
      //     input: 'coucou',
      //     combobox: people[0]
      // }),
      CST: {
        icons: [{ label: "Envelope", icon: j }, { label: "Funnel", icon: ee }, { label: "Flag", icon: Ye }],
        validationRules: [
          { label: "required", validation: { required: D } },
          { label: "minLength3", validation: { required: D, minLength: _(3) } },
          { label: "minLength15", validation: { required: D, minLength: _(15) } },
          { label: "maxLength3", validation: { maxLength: Pe(3) } }
        ],
        now: (/* @__PURE__ */ new Date()).getTime(),
        nextMonth: Te(/* @__PURE__ */ new Date(), 1).getTime(),
        people: le,
        categories: oe,
        buttonsColors: J,
        buttonsFill: R,
        inputType: L,
        errorPositions: X
      }
    };
  }
});
class Le {
  constructor() {
    K(this, "validators", [(l) => (l ?? "").toLowerCase().indexOf("x") === -1]);
  }
  stringify(l) {
    return (l ?? "").toUpperCase();
  }
  parse(l) {
    if (l)
      return l.toLowerCase();
  }
}
const le = [{
  id: 1,
  firstname: "John",
  lastname: "Doe"
}, {
  id: 2,
  firstname: "Jane",
  lastname: "Doe"
}, {
  id: 3,
  firstname: "Jay",
  lastname: "Doe"
}, {
  id: 4,
  firstname: "John",
  lastname: "Roe"
}, {
  id: 5,
  firstname: "Jane",
  lastname: "Roe"
}, {
  id: 6,
  firstname: "Jay",
  lastname: "Roe"
}, {
  id: 7,
  firstname: "John",
  lastname: "Toe"
}, {
  id: 8,
  firstname: "Jane",
  lastname: "Toe"
}, {
  id: 9,
  firstname: "Jay",
  lastname: "Toe"
}], oe = [{
  id: 1,
  label: "catégorie 1"
}, {
  id: 2,
  label: "catégorie 2"
}, {
  id: 3,
  label: "catégorie 3"
}, {
  id: 4,
  label: "catégorie 4"
}, {
  id: 5,
  label: "catégorie 5"
}, {
  id: 6,
  label: "catégorie 6"
}, {
  id: 7,
  label: "catégorie 7"
}, {
  id: 8,
  label: "catégorie 8"
}, {
  id: 9,
  label: "catégorie 9"
}], $e = { class: "t-demo" }, Ae = { class: "tt-flex tt-flex-nowrap" }, Be = {
  key: 0,
  class: "tt-ml-auto tt-self-center tt-pr-3"
}, Ne = { class: "tt-col-start-1" }, Oe = {
  key: 0,
  class: "px-1 bg-white cursor-pointer"
}, ze = {
  key: 1,
  class: "tt-text-sm tt-text-gray-400"
}, Ee = { class: "tt-px-1 tt-cursor-pointer" }, He = {
  key: 0,
  class: "tt-flex tt-items-center tt-bg-gray-100 tt-px-2 tt-rounded"
}, je = { class: "tt-px-2 tt-cursor-pointer" }, Je = { class: "tt-col-span-full tt-flex tt-justify-center" }, Re = { class: "tt-col-start-1 tt-flex tt-items-center tt-justify-between" }, Xe = { key: 1 }, Ze = { key: 1 }, qe = { class: "tt-col-span-full tt-border-b tt-text-center" }, Ge = { class: "tt-col-span-full tt-border-b tt-text-center" }, Ke = { class: "tt-col-span-full tt-border-b tt-text-center" }, Qe = { class: "col-span-1/2 tt-text-center" }, We = { class: "col-span-1/2 tt-text-center" }, xe = { class: "col-span-1/2 tt-text-center" }, _e = { class: "col-span-1/2 tt-text-center" }, el = { class: "col-span-1/2 tt-text-center" }, ll = { class: "col-span-1/2 tt-text-center" }, ol = { class: "col-span-1/2 tt-text-center" }, tl = { class: "col-span-1/2 tt-text-center" }, nl = { class: "col-span-1/2 tt-text-center" }, al = { class: "col-span-1/2 tt-text-center" }, sl = { class: "col-span-1/2 tt-text-center" }, dl = { class: "col-span-1/2 tt-text-center" }, il = { class: "tt-text-sm" }, ml = { class: "tt-text-sm" }, rl = { class: "tt-text-sm" }, ul = { class: "tt-text-sm" }, pl = { class: "tt-text-sm" }, bl = { class: "tt-text-sm" }, Vl = { class: "tt-text-sm" }, vl = { class: "tt-text-sm" }, cl = { class: "tt-col-start-1" }, fl = { class: "tt-text-sm" }, wl = { class: "tt-text-sm" }, kl = { class: "tt-text-sm" }, Tl = { class: "tt-text-sm" }, Pl = { class: "tt-text-sm" }, gl = { class: "tt-text-sm" }, Il = { class: "tt-text-sm" }, Sl = { class: "tt-text-sm" }, Cl = { class: "tt-col-start-1" }, yl = { class: "tt-col-start-1 tt-text-right" }, hl = { class: "tt-col-start-1 tt-text-center" }, Ul = { class: "tt-text-center" }, Ml = { class: "tt-text-center" }, Yl = { class: "tt-text-center" }, Dl = { class: "tt-col-span-2" }, Fl = { class: "tt-col-span-2" };
function Ll(e, l, C, J, R, X) {
  const L = m("ChevronDownIcon"), $ = m("ChevronUpIcon"), F = m("CheckIcon"), p = m("TCombobox"), k = m("DemoSection"), b = m("TSelect"), s = m("CloudIcon"), V = m("TrashIcon"), T = m("TRadio"), y = m("TCheckbox"), h = m("TInput"), A = m("TButtonIcon"), Y = m("TInputNumberInteger"), Z = m("TInputNumber"), te = m("TInputNumberDuration"), ne = m("TInputEmail"), ae = m("TInputPassword"), se = m("TInputNumberPercent"), de = m("TInputSearch"), ie = m("TInputTel"), me = m("TInputUrl"), re = m("TInputNumberFloat"), U = m("TDatetime"), B = m("TButton"), N = m("TDropdown"), q = m("TSwitch"), G = m("TCheckboxes"), ue = fe("vuelidate");
  return d(), r("div", $e, [
    t("span", {
      class: "tt-bg-white tt-rounded tt-border tt-p-2 tt-cursor-pointer",
      title: "fold/unfold all",
      onClick: l[0] || (l[0] = (o) => e.setAllSections(!e.allSectionsIsOpened))
    }, [
      e.allSectionsIsOpened ? (d(), c(L, {
        key: 0,
        class: "tt-inline-block tt-w-5"
      })) : (d(), c($, {
        key: 1,
        class: "tt-inline-block tt-w-5"
      }))
    ]),
    n(k, {
      title: "Combobox (Autocomplete)",
      description: "Complétion d'une liste de choix suggérés",
      open: e.sections[0]
    }, {
      default: i(() => [
        n(p, {
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox1,
          "onUpdate:modelValue": l[1] || (l[1] = (o) => e.model.combobox1 = o),
          placeholder: "Combobox test"
        }, {
          default: i(({ opt: o, selected: I, active: S }) => [
            t("div", Ae, [
              t("span", {
                class: z(["block truncate", { "tt-font-medium": I, "tt-font-normal": !I }])
              }, [
                t("div", null, a(o.firstname) + " " + a(o.lastname), 1),
                t("div", {
                  class: z({ "tt-text-white": S, "tt-text-gray-400": !S })
                }, a(o.email), 3)
              ], 2),
              I ? (d(), r("span", Be, [
                n(F, {
                  class: "tt-h-5 tt-w-5",
                  "aria-hidden": "true"
                })
              ])) : M("", !0)
            ])
          ]),
          _: 1
        }, 8, ["options-search", "options-label", "modelValue"]),
        n(p, {
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox3,
          "onUpdate:modelValue": l[2] || (l[2] = (o) => e.model.combobox3 = o),
          placeholder: "Combobox nullable",
          nullable: ""
        }, null, 8, ["options-search", "options-label", "modelValue"]),
        n(p, {
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox4,
          "onUpdate:modelValue": l[3] || (l[3] = (o) => e.model.combobox4 = o),
          placeholder: "Combobox disabled",
          disabled: ""
        }, null, 8, ["options-search", "options-label", "modelValue"]),
        n(p, {
          class: "tt-col-start-1",
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox2,
          "onUpdate:modelValue": l[4] || (l[4] = (o) => e.model.combobox2 = o),
          placeholder: "Combobox multiple",
          multiple: ""
        }, null, 8, ["options-search", "options-label", "modelValue"]),
        n(p, {
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox21,
          "onUpdate:modelValue": l[5] || (l[5] = (o) => e.model.combobox21 = o),
          placeholder: "Combobox multiple nullable",
          multiple: "",
          nullable: ""
        }, null, 8, ["options-search", "options-label", "modelValue"]),
        n(p, {
          class: "tt-col-start-1",
          "options-search": e.searchPeople,
          "options-label": e.labelPerson,
          modelValue: e.model.combobox3,
          "onUpdate:modelValue": l[6] || (l[6] = (o) => e.model.combobox3 = o),
          placeholder: "Combobox nullable on top",
          nullable: "",
          top: ""
        }, null, 8, ["options-search", "options-label", "modelValue"]),
        l[70] || (l[70] = t("div", { class: "tt-col-start-1 tt-px-1 tt-text-gray-500 tt-flex tt-items-center" }, "simulation d'une recherche lente:", -1)),
        n(p, {
          "options-search": (o) => e.searchPeople(o, 500),
          "options-label": e.labelPerson,
          modelValue: e.model.combobox5,
          "onUpdate:modelValue": l[7] || (l[7] = (o) => e.model.combobox5 = o),
          placeholder: "Combobox loading",
          nullable: ""
        }, null, 8, ["options-search", "options-label", "modelValue"])
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Listbox (Select)",
      description: "Liste de choix définis",
      open: e.sections[1]
    }, {
      default: i(() => [
        n(b, {
          modelValue: e.model.select1,
          "onUpdate:modelValue": l[8] || (l[8] = (o) => e.model.select1 = o),
          class: "tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select"
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select2,
          "onUpdate:modelValue": l[9] || (l[9] = (o) => e.model.select2 = o),
          class: "tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select nullable",
          nullable: ""
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select3,
          "onUpdate:modelValue": l[10] || (l[10] = (o) => e.model.select3 = o),
          class: "tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select disabled",
          disabled: ""
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select3a,
          "onUpdate:modelValue": l[11] || (l[11] = (o) => e.model.select3a = o),
          class: "tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select disabled with value",
          disabled: ""
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select4,
          "onUpdate:modelValue": l[12] || (l[12] = (o) => e.model.select4 = o),
          class: "tt-col-start-1 tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select multiple",
          multiple: ""
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select5,
          "onUpdate:modelValue": l[13] || (l[13] = (o) => e.model.select5 = o),
          class: "tt-px-1",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories,
          placeholder: "Select multiple nullable",
          multiple: "",
          nullable: ""
        }, null, 8, ["modelValue", "options"]),
        n(b, {
          class: "tt-col-start-1",
          modelValue: e.model.select10,
          "onUpdate:modelValue": l[14] || (l[14] = (o) => e.model.select10 = o),
          validation: e.invalid,
          placeholder: "Select invalid",
          "options-label": "label",
          "options-key": "id",
          options: e.CST.categories
        }, null, 8, ["modelValue", "validation", "options"]),
        l[73] || (l[73] = t("div", { class: "tt-col-start-1 tt-px-1 tt-text-gray-500" }, "exemple technique avec transformation:", -1)),
        n(b, {
          modelValue: e.model.select6,
          "onUpdate:modelValue": l[15] || (l[15] = (o) => e.model.select6 = o),
          class: "tt-col-start-1 tt-px-1",
          "options-label": "label",
          options: e.CST.categories,
          placeholder: "Select",
          "options-value": (o) => o == null ? void 0 : o.id
        }, null, 8, ["modelValue", "options", "options-value"]),
        n(b, {
          modelValue: e.model.select7,
          "onUpdate:modelValue": l[16] || (l[16] = (o) => e.model.select7 = o),
          class: "tt-px-1",
          "options-label": "label",
          options: e.CST.categories,
          placeholder: "Select multiple",
          "options-value": (o) => o == null ? void 0 : o.id,
          multiple: ""
        }, null, 8, ["modelValue", "options", "options-value"]),
        n(b, {
          modelValue: e.model.select8,
          "onUpdate:modelValue": l[17] || (l[17] = (o) => e.model.select8 = o),
          class: "tt-px-1",
          "options-label": "label",
          options: e.CST.categories,
          placeholder: "Select",
          "options-value": (o) => o == null ? void 0 : o.id
        }, null, 8, ["modelValue", "options", "options-value"]),
        n(b, {
          modelValue: e.model.select9,
          "onUpdate:modelValue": l[18] || (l[18] = (o) => e.model.select9 = o),
          class: "tt-px-1",
          "options-label": "label",
          options: e.CST.categories,
          placeholder: "Select multiple",
          "options-value": (o) => o == null ? void 0 : o.id,
          multiple: ""
        }, null, 8, ["modelValue", "options", "options-value"]),
        t("div", Ne, a(e.model.select6), 1),
        t("div", null, a(e.model.select7), 1),
        t("div", null, a(e.model.select8), 1),
        t("div", null, a(e.model.select9), 1),
        n(b, {
          modelValue: e.model.select11,
          "onUpdate:modelValue": l[19] || (l[19] = (o) => e.model.select11 = o),
          class: "tt-col-start-1",
          options: e.CST.people,
          placeholder: "Select template",
          "options-key": "id"
        }, {
          inputs: i(({ value: o }) => [
            o ? (d(), r("span", Oe, [
              n(s, { class: "tt-w-4 tt-inline-block" }),
              v(" " + a(o.firstname) + " " + a(o.lastname) + " ", 1),
              n(s, { class: "tt-w-4 tt-inline-block" })
            ])) : (d(), r("span", ze, [
              l[71] || (l[71] = v(" placeholder ")),
              n(s, { class: "tt-w-4 tt-inline-block" })
            ]))
          ]),
          default: i(({ opt: o }) => [
            t("div", Ee, a(o == null ? void 0 : o.firstname) + " " + a(o == null ? void 0 : o.lastname), 1)
          ]),
          end: i(({ active: o }) => [
            t("div", {
              class: z(["tt-w-full tt-cursor-pointer", { "tt-bg-ocean tt-text-white": o, "tt-text-ocean": !o }])
            }, [
              n(s, { class: "tt-w-4 tt-inline-block" }),
              l[72] || (l[72] = v(" XXX ")),
              n(s, { class: "tt-w-4 tt-inline-block" })
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "options"]),
        n(b, {
          modelValue: e.model.select12,
          "onUpdate:modelValue": l[20] || (l[20] = (o) => e.model.select12 = o),
          options: e.CST.people,
          placeholder: "Select multiple template",
          "options-key": "id",
          multiple: ""
        }, {
          input: i(({ value: o, remove: I }) => [
            o ? (d(), r("div", He, [
              v(a(o == null ? void 0 : o.firstname) + " " + a(o == null ? void 0 : o.lastname) + "   ", 1),
              n(V, {
                class: "tt-w-4 tt-inline-block",
                onClick: (S) => I()
              }, null, 8, ["onClick"])
            ])) : M("", !0)
          ]),
          default: i(({ opt: o, selected: I }) => [
            t("div", je, [
              v(a(o == null ? void 0 : o.firstname) + " " + a(o == null ? void 0 : o.lastname) + " ", 1),
              I ? (d(), c(F, {
                key: 0,
                class: "tt-w-4 tt-inline-block"
              })) : M("", !0)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Input",
      open: e.sections[4],
      onRefresh: l[52] || (l[52] = (o) => e.model$.$record())
    }, {
      parameters: i(() => [
        t("div", Je, [
          n(T, {
            class: "tt-w-1/2",
            modelValue: e.model.inputParam._type,
            "onUpdate:modelValue": l[21] || (l[21] = (o) => e.model.inputParam._type = o),
            options: [...e.CST.inputType]
          }, null, 8, ["modelValue", "options"])
        ]),
        l[92] || (l[92] = t("span", { class: "tt-col-span-full tt-text-center tt-border-b tt-font-medium" }, "statut", -1)),
        l[93] || (l[93] = t("span", { class: "tt-col-start-1" }, "disabled", -1)),
        n(y, {
          modelValue: e.model.inputParam.disabled,
          "onUpdate:modelValue": l[22] || (l[22] = (o) => e.model.inputParam.disabled = o),
          placeholder: "disabled"
        }, null, 8, ["modelValue"]),
        e.model.inputParam._type !== "custom" ? (d(), r(f, { key: 0 }, [
          l[76] || (l[76] = t("span", { class: "tt-col-span-full tt-text-center tt-border-b tt-font-medium" }, "common", -1)),
          l[77] || (l[77] = t("span", { class: "tt-col-start-1" }, "placeholder si aucune valeur. titre sinon", -1)),
          n(h, {
            modelValue: e.model.inputParam.placeholder,
            "onUpdate:modelValue": l[23] || (l[23] = (o) => e.model.inputParam.placeholder = o),
            placeholder: "placeholder"
          }, null, 8, ["modelValue"]),
          l[78] || (l[78] = t("span", { class: "tt-col-start-1" }, "ajouter au placeholder", -1)),
          n(h, {
            modelValue: e.model.inputParam.default,
            "onUpdate:modelValue": l[24] || (l[24] = (o) => e.model.inputParam.default = o),
            placeholder: "default"
          }, null, 8, ["modelValue"]),
          t("span", Re, [
            l[75] || (l[75] = t("span", null, "validation", -1)),
            n(A, {
              onClick: l[25] || (l[25] = (o) => e.model$.$touch()),
              title: "force dirty state"
            }, {
              default: i(() => l[74] || (l[74] = [
                v(" dirty ")
              ])),
              _: 1
            })
          ]),
          n(b, {
            modelValue: e.model$vargs.input,
            "onUpdate:modelValue": l[26] || (l[26] = (o) => e.model$vargs.input = o),
            options: e.CST.validationRules,
            "options-value": (o) => o == null ? void 0 : o.validation,
            "options-label": "label",
            nullable: ""
          }, null, 8, ["modelValue", "options", "options-value"]),
          l[79] || (l[79] = t("span", { class: "tt-col-start-1" }, "position du tooltip d'erreur", -1)),
          n(b, {
            modelValue: e.model.inputParam.errorPosition,
            "onUpdate:modelValue": l[27] || (l[27] = (o) => e.model.inputParam.errorPosition = o),
            options: [...e.CST.errorPositions],
            nullable: ""
          }, null, 8, ["modelValue", "options"]),
          l[80] || (l[80] = t("span", { class: "tt-col-start-1" }, "start", -1)),
          n(h, {
            modelValue: e.model.inputParam.start,
            "onUpdate:modelValue": l[28] || (l[28] = (o) => e.model.inputParam.start = o),
            placeholder: "start"
          }, null, 8, ["modelValue"]),
          l[81] || (l[81] = t("span", { class: "tt-col-start-1" }, [
            v(" startIcon (see: "),
            t("a", {
              href: "https://heroicons.com/",
              target: "_blank"
            }, "heroicons"),
            v(") ")
          ], -1)),
          n(b, {
            modelValue: e.model.inputParam.startIcon,
            "onUpdate:modelValue": l[29] || (l[29] = (o) => e.model.inputParam.startIcon = o),
            options: e.CST.icons,
            "options-value": (o) => o == null ? void 0 : o.icon,
            nullable: "",
            "options-key": "label"
          }, {
            default: i(({ opt: o }) => [
              (d(), c(g(o.icon), { class: "tt-w-4 tt-py-1 tt-ml-4" }))
            ]),
            inputs: i(({ value: o }) => [
              o ? (d(), c(g(o.icon), {
                key: 0,
                class: "tt-w-4 tt-py-1"
              })) : (d(), r("span", Xe, " "))
            ]),
            _: 1
          }, 8, ["modelValue", "options", "options-value"]),
          l[82] || (l[82] = t("span", { class: "tt-col-start-1" }, "end", -1)),
          n(h, {
            modelValue: e.model.inputParam.end,
            "onUpdate:modelValue": l[30] || (l[30] = (o) => e.model.inputParam.end = o),
            placeholder: "end"
          }, null, 8, ["modelValue"]),
          l[83] || (l[83] = t("span", { class: "tt-col-start-1" }, [
            v(" endIcon (see: "),
            t("a", {
              href: "https://heroicons.com/",
              target: "_blank"
            }, "heroicons"),
            v(") ")
          ], -1)),
          n(b, {
            modelValue: e.model.inputParam.endIcon,
            "onUpdate:modelValue": l[31] || (l[31] = (o) => e.model.inputParam.endIcon = o),
            options: e.CST.icons,
            "options-value": (o) => o == null ? void 0 : o.icon,
            nullable: "",
            "options-key": "label"
          }, {
            default: i(({ opt: o }) => [
              (d(), c(g(o.icon), { class: "tt-w-4 tt-py-1 tt-ml-4" }))
            ]),
            inputs: i(({ value: o }) => [
              o ? (d(), c(g(o.icon), {
                key: 0,
                class: "tt-w-4 tt-py-1"
              })) : (d(), r("span", Ze, " "))
            ]),
            _: 1
          }, 8, ["modelValue", "options", "options-value"])
        ], 64)) : M("", !0),
        e.model.inputParam._type === "number" ? (d(), r(f, { key: 1 }, [
          t("span", qe, a(e.model.inputParam._type), 1),
          l[84] || (l[84] = t("span", { class: "tt-col-start-1" }, "min", -1)),
          n(Y, {
            modelValue: e.model.inputParam.min,
            "onUpdate:modelValue": l[32] || (l[32] = (o) => e.model.inputParam.min = o),
            placeholder: "min"
          }, null, 8, ["modelValue"]),
          l[85] || (l[85] = t("span", { class: "tt-col-start-1" }, "max", -1)),
          n(Y, {
            modelValue: e.model.inputParam.max,
            "onUpdate:modelValue": l[33] || (l[33] = (o) => e.model.inputParam.max = o),
            placeholder: "max"
          }, null, 8, ["modelValue"]),
          l[86] || (l[86] = t("span", { class: "tt-col-start-1" }, "step", -1)),
          n(Z, {
            modelValue: e.model.inputParam.step,
            "onUpdate:modelValue": l[34] || (l[34] = (o) => e.model.inputParam.step = o),
            placeholder: "step",
            default: "25 / 0.001",
            precision: "20"
          }, null, 8, ["modelValue"]),
          l[87] || (l[87] = t("span", { class: "tt-col-start-1" }, "stepMandatory", -1)),
          n(y, {
            modelValue: e.model.inputParam.stepMandatory,
            "onUpdate:modelValue": l[35] || (l[35] = (o) => e.model.inputParam.stepMandatory = o),
            placeholder: "stepMandatory"
          }, null, 8, ["modelValue"]),
          l[88] || (l[88] = t("span", { class: "tt-col-start-1" }, "precision", -1)),
          n(Y, {
            modelValue: e.model.inputParam.precision,
            "onUpdate:modelValue": l[36] || (l[36] = (o) => e.model.inputParam.precision = o),
            placeholder: "precision"
          }, null, 8, ["modelValue"])
        ], 64)) : e.model.inputParam._type === "text" ? (d(), r(f, { key: 2 }, [
          t("span", Ge, a(e.model.inputParam._type), 1),
          l[91] || (l[91] = t("span", { class: "tt-col-start-1" }, "multiline", -1)),
          n(y, {
            modelValue: e.model.inputParam.multiline,
            "onUpdate:modelValue": l[37] || (l[37] = (o) => e.model.inputParam.multiline = o),
            placeholder: "multiline"
          }, null, 8, ["modelValue"]),
          e.model.inputParam.multiline ? (d(), r(f, { key: 0 }, [
            t("span", Ke, a(e.model.inputParam._type) + " multiline ", 1),
            l[89] || (l[89] = t("span", { class: "tt-col-start-1" }, "nombre de lignes à l'initialisation", -1)),
            n(Y, {
              modelValue: e.model.inputParam.rows,
              "onUpdate:modelValue": l[38] || (l[38] = (o) => e.model.inputParam.rows = o),
              placeholder: "rows"
            }, null, 8, ["modelValue"]),
            l[90] || (l[90] = t("span", { class: "tt-col-start-1" }, "longueur maximum", -1)),
            n(Y, {
              modelValue: e.model.inputParam.maxlength,
              "onUpdate:modelValue": l[39] || (l[39] = (o) => e.model.inputParam.maxlength = o),
              placeholder: "maxlength"
            }, null, 8, ["modelValue"])
          ], 64)) : M("", !0)
        ], 64)) : M("", !0)
      ]),
      default: i(() => [
        e.model.inputParam._type === "text" ? (d(), r(f, { key: 0 }, [
          n(h, w({
            class: "col-span-1/2",
            modelValue: e.model.input,
            "onUpdate:modelValue": l[40] || (l[40] = (o) => e.model.input = o)
          }, e.model.inputParam, {
            validation: e.model$.input
          }), E({ _: 2 }, [
            e.model.inputParam.startIcon ? {
              name: "start",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.startIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "0"
            } : void 0,
            e.model.inputParam.endIcon ? {
              name: "end",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.endIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "1"
            } : void 0
          ]), 1040, ["modelValue", "validation"]),
          t("pre", Qe, a(e.model.input ?? " "), 1),
          n(h, w({
            class: "col-span-1/2",
            modelValue: e.model.inputTestFormatter,
            "onUpdate:modelValue": l[41] || (l[41] = (o) => e.model.inputTestFormatter = o)
          }, e.model.inputParam, {
            validation: e.model$.input,
            formatter: e.testInputFormatter,
            placeholder: "input with custom formatter"
          }), E({ _: 2 }, [
            e.model.inputParam.startIcon ? {
              name: "start",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.startIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "0"
            } : void 0,
            e.model.inputParam.endIcon ? {
              name: "end",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.endIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "1"
            } : void 0
          ]), 1040, ["modelValue", "validation", "formatter"]),
          t("pre", We, a(e.model.inputTestFormatter ?? " "), 1)
        ], 64)) : e.model.inputParam._type === "number" ? (d(), r(f, { key: 1 }, [
          n(Z, w({
            class: "col-span-1/2",
            modelValue: e.model.input,
            "onUpdate:modelValue": l[42] || (l[42] = (o) => e.model.input = o)
          }, e.model.inputParam, {
            validation: e.model$.input
          }), E({ _: 2 }, [
            e.model.inputParam.startIcon ? {
              name: "start",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.startIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "0"
            } : void 0,
            e.model.inputParam.endIcon ? {
              name: "end",
              fn: i(() => [
                (d(), c(g(e.model.inputParam.endIcon), { class: "tt-w-7 tw-text-primary tt-z-10 tt-px-1" }))
              ]),
              key: "1"
            } : void 0
          ]), 1040, ["modelValue", "validation"]),
          t("pre", xe, a(e.model.input ?? " "), 1)
        ], 64)) : e.model.inputParam._type === "custom" ? (d(), r(f, { key: 2 }, [
          l[94] || (l[94] = t("div", { class: "tt-col-start-1 tt-px-1 tt-text-gray-500 tt-flex tt-items-center" }, " preset: ", -1)),
          n(te, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS1,
            "onUpdate:modelValue": l[43] || (l[43] = (o) => e.model.inputS1 = o)
          }, e.inputParamInputDuration, { placeholder: "input-duration" }), null, 16, ["modelValue"]),
          t("pre", _e, a(e.model.inputS1 ?? " "), 1),
          n(ne, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS2,
            "onUpdate:modelValue": l[44] || (l[44] = (o) => e.model.inputS2 = o)
          }, e.inputParamInputEmail, { placeholder: "input-email" }), null, 16, ["modelValue"]),
          t("pre", el, a(e.model.inputS2 ?? " "), 1),
          n(ae, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS3,
            "onUpdate:modelValue": l[45] || (l[45] = (o) => e.model.inputS3 = o)
          }, e.inputParamInputPassword, { placeholder: "input-password" }), null, 16, ["modelValue"]),
          t("pre", ll, a(e.model.inputS3 ?? " "), 1),
          n(se, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS4,
            "onUpdate:modelValue": l[46] || (l[46] = (o) => e.model.inputS4 = o)
          }, e.inputParamInputPercent, { placeholder: "input-percent" }), null, 16, ["modelValue"]),
          t("pre", ol, a(e.model.inputS4 ?? " "), 1),
          n(de, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS5,
            "onUpdate:modelValue": l[47] || (l[47] = (o) => e.model.inputS5 = o)
          }, e.inputParamInputSearch, { placeholder: "input-search" }), null, 16, ["modelValue"]),
          t("pre", tl, a(e.model.inputS5 ?? " "), 1),
          n(ie, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS6,
            "onUpdate:modelValue": l[48] || (l[48] = (o) => e.model.inputS6 = o)
          }, e.inputParamInputTel, { placeholder: "input-tel" }), null, 16, ["modelValue"]),
          t("pre", nl, a(e.model.inputS6 ?? " "), 1),
          n(me, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS7,
            "onUpdate:modelValue": l[49] || (l[49] = (o) => e.model.inputS7 = o)
          }, e.inputParamInputUrl, { placeholder: "input-url" }), null, 16, ["modelValue"]),
          t("pre", al, a(e.model.inputS7 ?? " "), 1),
          n(Y, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS8,
            "onUpdate:modelValue": l[50] || (l[50] = (o) => e.model.inputS8 = o)
          }, e.inputParamInputInteger, { placeholder: "input-integer" }), null, 16, ["modelValue"]),
          t("pre", sl, a(e.model.inputS8 ?? " "), 1),
          n(re, w({
            class: "col-span-1/2",
            modelValue: e.model.inputS9,
            "onUpdate:modelValue": l[51] || (l[51] = (o) => e.model.inputS9 = o)
          }, e.inputParamInputFoat, { placeholder: "input-float" }), null, 16, ["modelValue"]),
          t("pre", dl, a(e.model.inputS9 ?? " "), 1)
        ], 64)) : M("", !0)
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Date",
      open: e.sections[5]
    }, {
      default: i(() => [
        t("span", null, [
          n(U, {
            utc: !1,
            modelValue: e.model.date1,
            "onUpdate:modelValue": l[53] || (l[53] = (o) => e.model.date1 = o),
            validation: e.model$.date1,
            placeholder: "Date"
          }, null, 8, ["modelValue", "validation"]),
          t("div", il, a(e.dateLocalF(e.model.date1)), 1),
          t("div", ml, a(e.dateF(e.model.date1)) + a(e.model.date1 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            utc: !1,
            modelValue: e.model.date2,
            "onUpdate:modelValue": l[54] || (l[54] = (o) => e.model.date2 = o),
            placeholder: "Date nullable",
            raz: ""
          }, null, 8, ["modelValue"]),
          t("div", rl, a(e.dateLocalF(e.model.date2, "dd/MM/YYY H:mm O")), 1),
          t("div", ul, a(e.dateF(e.model.date2, "dd/MM/YYY H:mm")) + a(e.model.date2 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            utc: !1,
            modelValue: e.model.date3,
            "onUpdate:modelValue": l[55] || (l[55] = (o) => e.model.date3 = o),
            placeholder: "Date with time",
            "minimum-view": "time"
          }, null, 8, ["modelValue"]),
          t("div", pl, a(e.dateLocalF(e.model.date3, "dd/MM/YYY H:mm O")), 1),
          t("div", bl, a(e.dateF(e.model.date3, "dd/MM/YYY H:mm")) + a(e.model.date3 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            utc: !1,
            modelValue: e.model.date4,
            "onUpdate:modelValue": l[56] || (l[56] = (o) => e.model.date4 = o),
            placeholder: "Date with min max",
            min: e.CST.now,
            max: e.CST.nextMonth
          }, null, 8, ["modelValue", "min", "max"]),
          t("div", Vl, a(e.dateLocalF(e.model.date4, "dd/MM/YYY H:mm O")), 1),
          t("div", vl, a(e.dateF(e.model.date4, "dd/MM/YYY H:mm")) + a(e.model.date4 ? " UTC" : ""), 1)
        ]),
        t("span", cl, [
          n(U, {
            modelValue: e.model.date5,
            "onUpdate:modelValue": l[57] || (l[57] = (o) => e.model.date5 = o),
            placeholder: "Date UTC"
          }, null, 8, ["modelValue"]),
          t("div", fl, a(e.dateLocalF(e.model.date5, "dd/MM/YYY H:mm O")), 1),
          t("div", wl, a(e.dateF(e.model.date5, "dd/MM/YYY H:mm")) + a(e.model.date5 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            modelValue: e.model.date6,
            "onUpdate:modelValue": l[58] || (l[58] = (o) => e.model.date6 = o),
            placeholder: "Date UTC nullable",
            raz: ""
          }, null, 8, ["modelValue"]),
          t("div", kl, a(e.dateLocalF(e.model.date6, "dd/MM/YYY H:mm O")), 1),
          t("div", Tl, a(e.dateF(e.model.date6, "dd/MM/YYY H:mm")) + a(e.model.date6 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            modelValue: e.model.date7,
            "onUpdate:modelValue": l[59] || (l[59] = (o) => e.model.date7 = o),
            placeholder: "Date UTC with time",
            "minimum-view": "time"
          }, null, 8, ["modelValue"]),
          t("div", Pl, a(e.dateLocalF(e.model.date7, "dd/MM/YYY H:mm O")), 1),
          t("div", gl, a(e.dateF(e.model.date7, "dd/MM/YYY H:mm")) + a(e.model.date7 ? " UTC" : ""), 1)
        ]),
        t("span", null, [
          n(U, {
            modelValue: e.model.date8,
            "onUpdate:modelValue": l[60] || (l[60] = (o) => e.model.date8 = o),
            placeholder: "Date UTC with min max",
            min: e.CST.now,
            max: e.CST.nextMonth
          }, null, 8, ["modelValue", "min", "max"]),
          t("div", Il, a(e.dateLocalF(e.model.date8, "dd/MM/YYY H:mm O")), 1),
          t("div", Sl, a(e.dateF(e.model.date8, "dd/MM/YYY H:mm")) + a(e.model.date8 ? " UTC" : ""), 1)
        ]),
        l[95] || (l[95] = t("div", { class: "tt-col-start-1" }, "Pour simuler un décalage horaire, sous chrome:", -1)),
        l[96] || (l[96] = t("ol", { class: "tt-list-decimal tt-list-inside sm:tt-col-start-2 tt-col-end-[-1]" }, [
          t("li", null, "ouvrir le debugger (clic droit inspecter)"),
          t("li", null, "3 dots > more tools > sensors"),
          t("li", null, "change location + refresh")
        ], -1))
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Button",
      open: e.sections[6]
    }, {
      default: i(() => [
        (d(!0), r(f, null, H(e.CST.buttonsColors, (o, I) => (d(), r(f, { key: o }, [
          t("span", Cl, a(o) + a(I === 0 ? " *" : ""), 1),
          (d(!0), r(f, null, H(e.CST.buttonsFill, (S, pe) => (d(), r(f, null, [
            t("span", yl, a(S) + a(pe === 0 ? " *" : ""), 1),
            n(B, {
              color: o,
              onClick: e.consoleLog,
              fill: S
            }, {
              default: i(() => l[97] || (l[97] = [
                v(" ... ")
              ])),
              _: 2
            }, 1032, ["color", "onClick", "fill"]),
            n(B, {
              color: o,
              disabled: "",
              onClick: e.consoleLog,
              fill: S
            }, {
              default: i(() => l[98] || (l[98] = [
                v(" disabled ")
              ])),
              _: 2
            }, 1032, ["color", "onClick", "fill"]),
            ke((d(), c(B, {
              color: o,
              fill: S
            }, {
              default: i(() => l[99] || (l[99] = [
                v(" invalid ")
              ])),
              _: 2
            }, 1032, ["color", "fill"])), [
              [ue, () => ({ click: e.consoleLog, validation: e.invalid })]
            ]),
            n(B, {
              color: o,
              round: "",
              onClick: e.consoleLog,
              fill: S
            }, {
              default: i(() => l[100] || (l[100] = [
                v(" round ")
              ])),
              _: 2
            }, 1032, ["color", "onClick", "fill"])
          ], 64))), 256))
        ], 64))), 128))
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Button icon",
      open: e.sections[7]
    }, {
      default: i(() => [
        (d(!0), r(f, null, H([void 0, ...e.CST.buttonsColors], (o) => (d(), r(f, { key: o }, [
          t("span", hl, a(o), 1),
          t("span", Ul, [
            n(A, {
              color: o,
              title: "small"
            }, {
              default: i(() => [
                n(s)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          t("span", Ml, [
            n(A, {
              color: o,
              title: "defaut",
              size: "md"
            }, {
              default: i(() => [
                n(s)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          t("span", Yl, [
            n(A, {
              color: o,
              title: "large",
              size: "xl"
            }, {
              default: i(() => [
                n(s)
              ]),
              _: 2
            }, 1032, ["color"])
          ])
        ], 64))), 128))
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Button dropdown",
      open: e.sections[8]
    }, {
      default: i(() => [
        n(N, { items: e.dropdownItems }, null, 8, ["items"]),
        n(N, { items: e.dropdownItems }, {
          default: i(({ open: o }) => [
            v(a(o ? "XXX" : "YYY"), 1)
          ]),
          _: 1
        }, 8, ["items"]),
        n(N, null, {
          default: i(({ open: o }) => [
            v(a(o ? "XXX" : "YYY"), 1)
          ]),
          content: i(({ close: o }) => l[101] || (l[101] = [
            t("div", {
              style: { height: "120vh" },
              class: "tt-bg-gray-100 p-4"
            }, " test d'une dropdown trop grande => scroll ", -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Switch",
      open: e.sections[8]
    }, {
      default: i(() => [
        t("span", Dl, [
          n(q, {
            modelValue: e.model.switch1,
            "onUpdate:modelValue": l[61] || (l[61] = (o) => e.model.switch1 = o),
            title: "title",
            description: "description switch size s",
            on: 1,
            off: 2,
            size: "s"
          }, null, 8, ["modelValue"])
        ]),
        t("span", Fl, [
          n(q, {
            modelValue: e.model.switch1,
            "onUpdate:modelValue": l[62] || (l[62] = (o) => e.model.switch1 = o),
            title: "title",
            description: "description switch size m",
            on: 1,
            off: 2,
            size: "m"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    n(k, {
      title: "Checkboxes",
      open: e.sections[9]
    }, {
      default: i(() => [
        n(y, {
          modelValue: e.model.checkbox1,
          "onUpdate:modelValue": l[63] || (l[63] = (o) => e.model.checkbox1 = o),
          indeterminate: "",
          label: "checkbox indeterminate",
          onChange: l[64] || (l[64] = (o) => e.consoleLog("checkbox event change"))
        }, null, 8, ["modelValue"]),
        n(y, {
          modelValue: e.model.checkbox2,
          "onUpdate:modelValue": l[65] || (l[65] = (o) => e.model.checkbox2 = o),
          label: "checkbox",
          class: "!w-8"
        }, null, 8, ["modelValue"]),
        n(y, {
          modelValue: e.model.checkbox1,
          "onUpdate:modelValue": l[66] || (l[66] = (o) => e.model.checkbox1 = o),
          label: "checkbox disabled",
          disabled: ""
        }, null, 8, ["modelValue"]),
        n(y, {
          modelValue: e.model.checkbox1,
          "onUpdate:modelValue": l[67] || (l[67] = (o) => e.model.checkbox1 = o),
          label: "checkbox invalid",
          validation: e.invalid
        }, null, 8, ["modelValue", "validation"]),
        l[102] || (l[102] = t("span", { class: "tt-col-start-1" }, "vertical", -1)),
        n(G, {
          modelValue: e.model.checkboxes,
          "onUpdate:modelValue": l[68] || (l[68] = (o) => e.model.checkboxes = o),
          "options-value": ["A", "B", "C"]
        }, null, 8, ["modelValue"]),
        l[103] || (l[103] = t("span", { class: "tt-col-start-1" }, "horizontal", -1)),
        n(G, {
          modelValue: e.model.checkboxes,
          "onUpdate:modelValue": l[69] || (l[69] = (o) => e.model.checkboxes = o),
          "options-value": ["A", "B", "C"],
          inline: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["open"]),
    we(e.$slots, "default", { sections: e.extraSections }, void 0, !0)
  ]);
}
const El = /* @__PURE__ */ ye(Fe, [["render", Ll], ["__scopeId", "data-v-349a9501"]]);
export {
  El as default
};
//# sourceMappingURL=Demo-hi4P2ly9.js.map
